import {useContext, createContext} from 'react';
import {IContext} from './Types';

/**
 *
 */
export const Context = createContext({} as IContext);

/**
 *
 * @returns
 */
export function useContextState(): IContext {
  return useContext(Context);
}

export default useContextState;
